import type { SVGProps } from 'react';
const SvgIncomplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.023 2.628a.75.75 0 0 1 .54-.915 6.75 6.75 0 0 1 3.374 0 .75.75 0 1 1-.375 1.452 5.257 5.257 0 0 0-2.625 0 .75.75 0 0 1-.914-.537Zm-2.59.893a6.756 6.756 0 0 0-1.687 2.922.75.75 0 1 0 1.446.4 5.25 5.25 0 0 1 1.312-2.272.75.75 0 0 0-1.07-1.05Zm-.242 6.134a.75.75 0 0 0-1.445.4 6.75 6.75 0 0 0 1.687 2.925.75.75 0 0 0 1.067-1.052A5.25 5.25 0 0 1 3.19 9.655Zm6.371 3.679a5.25 5.25 0 0 1-2.625 0 .749.749 0 1 0-.375 1.452 6.75 6.75 0 0 0 3.375 0 .75.75 0 1 0-.375-1.452Zm4.67-4.201a.75.75 0 0 0-.92.523A5.25 5.25 0 0 1 12 11.928a.75.75 0 0 0 1.07 1.051 6.762 6.762 0 0 0 1.687-2.923.75.75 0 0 0-.525-.923Zm-.923-2.288a.75.75 0 0 0 1.445-.402 6.75 6.75 0 0 0-1.687-2.923A.75.75 0 1 0 12 4.57a5.25 5.25 0 0 1 1.309 2.274Z"
    />
  </svg>
);
export default SvgIncomplete;
